import React, { FC, PropsWithChildren, useCallback } from 'react';

import { Project as ProjectModel } from '@material-bank/projects-api';
import * as Styled from './ProjectButton.styles';

interface ProjectButtonProps {
  project: ProjectModel;
  selected?: boolean;
  onClick?(project: ProjectModel): void;
}

export const ProjectButton: FC<PropsWithChildren<ProjectButtonProps>> = (
  props,
) => {
  const { project, selected, onClick } = props;

  const onButtonClick = useCallback(() => {
    onClick?.(project);
  }, [onClick, project]);

  return (
    <Styled.Button
      variant="contained"
      color={selected ? 'primary' : 'secondary'}
      onClick={onButtonClick}
    >
      <span>{project.title}</span>
    </Styled.Button>
  );
};
